import { FormControlLabel } from "@mui/material";
import { Checkbox } from "@mui/material";
import React from "react";
import Label from "./LabelF";
import { esMinuscula } from "../../../helper/funciones";

const InputCheckbox = ({ setValor, valor, cab, error, setError, data }) => {
  const {
    label,
    textAlign,
    width,
    margin,
    padding,
    // filtrosAAplicar,
    // setFiltrosAAplicar,
    opcionales_null,
    permite_null,
    id_a,
    grid_span,
  } = cab;

  let s = "s";
  let n = "n";

  if (valor) {
    s = esMinuscula(valor.toString()) ? "s" : "S";
    n = esMinuscula(valor.toString()) ? "n" : "N";
  }

  const onChange = (e) => {
    setValor(e.target.checked ? s : n);
    setError((prev) => {
      const ne = { ...prev };
      ne[id_a] = false;
      return ne;
    });
  };

  const styles = {
    textAlign,
    width,
    margin,
    padding,
    gridColumn: grid_span,
  };

  return (
    <div style={styles}>
      <Label
        label={label}
        opcionales_null={opcionales_null}
        permite_null={permite_null}
      />
      <FormControlLabel
        control={
          <Checkbox
            onChange={onChange}
            checked={valor?.toString() === s?.toString()}
          />
        }
        label={label}
        style={{ marginLeft: "0px" }}
      />
    </div>
  );
};

export default InputCheckbox;
